import React, { useEffect } from "react";
import classes from "./App.module.css";
import Navbar from "./Components/Navbar.js";
import Header from "./Components/Header.js";
import Subtitle from "./Components/Subtitle.js";
import HeroShot from "./Components/HeroShot.js";
import CallToAction from "./Components/CallToAction.js";
import Convincing from "./Components/Convincing.js";
// import SocialProof from "./Components/SocialProof.js";
import AttributionsComp from "./Components/AttributionsComp.js";
import Gallery from "./Components/Gallery.js";
import FooterComp from "./Components/FooterComp/FooterComp.js";
import { Outlet, useLocation } from "react-router-dom";
import { useLocalStorageOrder } from "./hooks/useLocalStorageOrder.js";

function App() {
  const location = useLocation();
  const path = location.pathname;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [path]);

  useLocalStorageOrder();

  if (path === "/orders") {
    return (
      <>
        <Navbar />
        <Outlet />
      </>
    );
  }

  return (
    <>
      <main className={`${classes.container}`}>
        <Navbar />
        <Header />
        <Subtitle />
        <HeroShot />
        <div>
          <div className={classes.flexContainer}>
            <Convincing />
            <CallToAction />
          </div>
        </div>
        <Gallery />
        <footer>
          <FooterComp />
          <AttributionsComp />
        </footer>
      </main>
    </>
  );
}

export default App;
